"use client";

import { useSortable, defaultAnimateLayoutChanges, AnimateLayoutChanges } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { TierItemContent } from "@/components/tier-item-content";
import { GripVertical } from "lucide-react";

const animateLayoutChanges: AnimateLayoutChanges = (args) =>
  defaultAnimateLayoutChanges({ ...args, wasDragging: true });

export interface TierItem {
  id: string;
  label: string;
  labelColor: string;
  backgroundColor: string;
}

interface SortableTierItemProps {
  id: string;
  index: number;
  tier: TierItem;
  onLabelChange: (index: number, label: string) => void;
  openColorModal: (index: number) => void;
  removeTier: (index: number) => void;
  tiersLength: number;
}

export function SortableTierItem({
  id,
  index,
  tier,
  onLabelChange,
  openColorModal,
  removeTier,
  tiersLength,
}: SortableTierItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    animateLayoutChanges,
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition: transition || "transform 250ms ease",
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex gap-4 items-start p-4 border rounded-lg bg-card"
    >
      <div className="flex gap-2 items-center w-full">
        <button
          type="button"
          className="cursor-grab active:cursor-grabbing text-muted-foreground hover:text-foreground mr-2"
          {...attributes}
          {...listeners}
        >
          <GripVertical className="w-5 h-5" />
        </button>

        <TierItemContent
          tier={tier}
          index={index}
          onLabelChange={onLabelChange}
          openColorModal={openColorModal}
          removeTier={removeTier}
          tiersLength={tiersLength}
        />
      </div>
    </div>
  );
}
